import { Module } from "vuex";
import { IPaymentState } from "@/core/interfaces/state/paymentState.interface";
import { StoreState } from "@/store/type";

import mutations from "./mutations";
import actions from "./actions";
import state from "./state";
import getters from "./getters";

const paymentsModule: Module<IPaymentState, StoreState> = {
  state,
  mutations,
  actions,
  getters,
};

export default paymentsModule;
